/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef } from 'react'
import classes from '@src/styles/Header.module.css'
import { MdOutlinePowerSettingsNew } from 'react-icons/md'
import Link from 'next/link'
import dynamic from 'next/dist/shared/lib/dynamic'
import dimensionLogo from '@src/assets/dimension-logo.svg'
import dimensionLogoDark from '@src/assets/dimension-logo-dark.svg'
import accountIcon from '@src/assets/icons/user.svg'
import accountIconDark from '@src/assets/icons/user-dark.svg'
import MenuIcon from '@src/assets/menu-icon.svg'
import MenuIconDark from '@src/assets/menu-icon-dark.svg'
// import { roles } from '../../constants/roles'
// import LoginModal from '../LoginModal'
// import { signOut } from '../../store/actions/auth'
import useScrollPosition from '@src/hooks/useScrollPosition'
import useAppLink from '@src/hooks/useAppLink'
import { withAttribution } from '@src/functions/attribution'
import { useRouter } from 'next/router'
import { COMPANY_CREDENTIALS } from '@src/constants/credentials'
import queryString from 'query-string'
import { useMediaQuery } from 'react-responsive'
import {
  aboutUsMenuItems,
  accountMenuItems,
  businessMenuItems,
  providersMenuItems,
  loggedInSupportItems,
  supportMenuItems,
  loggedInCustomerSupportMenuItems,
  aboutUsMenuItemsCustomer,
  sustainabilityItems,
  ourServicesMenuItems,
} from './constants'
import HeaderMenuItem, { MENU_ROOT_ATTRIBUTE } from './HeaderMenuItem'

const MobileMenu = dynamic(() => import('./MobileMenu'))

const transparentRoutes = [
  '/',
  '/provider_portal',
  '/b2b-solutions',
  '/sustainability',
  '/about_us',
]

function Header({ opaque }: { opaque?: boolean }) {
  const history = useRouter()
  // Attribution params are stamped on at click time rather than read off the
  // current query, so the header CTA stays attributed once the visitor has
  // navigated away from the URL the ad landed on. See src/functions/attribution.ts.
  const appLink = useAppLink()
  const isMobile = useMediaQuery({ query: '(max-width:768px)' })
  const [showEditBusiness] = useState(false)
  const [showIntegrations] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false)
  const [isOpaque, setIsOpaque] = useState<boolean>(opaque ?? false)
  const [toggled, setToggled] = useState(null)

  const enableTransparent = transparentRoutes.includes(history.asPath)

  const subscribed = useRef(false)

  const isLoggedIn = false // useSelector((state: any) => state.firebase.auth?.uid)
  const profile = {
    uid: '1',
    email: '',
    userType: 'customer',
    approvalState: 'complete',
    isBanned: true,
    smsSettings: {
      address: {
        city: 'city',
      },
    },
  } // useSelector((state: any) => state.firebase.profile)
  const isProvider = profile?.userType === 'provider'
  const isApproved = !profile?.approvalState || profile?.approvalState === 'complete'
  const { isBanned } = profile
  const isBusinessAccount = false //! !useSelector((state: any) => state.firebase.profile.businessId)

  const scrollPosition = useScrollPosition()

  useEffect(() => {
    subscribed.current = true
    return () => {
      subscribed.current = false
    }
  }, [])

  const signOutMenuItem = {
    label: 'Sign Out',
    icon: <MdOutlinePowerSettingsNew color='primary' />,
    func: () => {},
    // func: () => dispatch(signOut()),
  }

  const toggleDrawer = (openDrawer: boolean) => (event: any) => {
    if (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift')) {
      // eslint-disable-next-line no-useless-return
      return
    }
    setIsDrawerOpen(openDrawer)
  }

  useEffect(() => {
    if (isDrawerOpen && isMobile) {
      document.body.setAttribute('style', 'overflow-y: hidden;')
    } else {
      document.body.setAttribute('style', 'overflow-y: auto;')
    }
  }, [isDrawerOpen])

  useEffect(() => {
    const offset = isMobile ? 30 : 200
    setIsOpaque(opaque || !enableTransparent ? true : Math.round(scrollPosition / offset) > 0)
  }, [scrollPosition, opaque, isMobile, enableTransparent])

  // Close the open dropdown when clicking anywhere outside of a header menu, or on Escape
  useEffect(() => {
    if (!toggled) return undefined

    const handleOutsideClick = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Element | null
      if (!target?.closest?.(`[${MENU_ROOT_ATTRIBUTE}]`)) {
        setToggled(null)
      }
    }
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setToggled(null)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('touchstart', handleOutsideClick)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [toggled])

  const headerClasses = {
    container: isOpaque ? classes.containerOpaque : classes.container,
  }

  const handleLogin = () => {
    history.push(
      withAttribution(
        `${process.env.NEXT_PUBLIC_REDIRECT_URL}?`.concat(
          queryString.stringify({
            login: '1',
            redirect: '1',
          }),
        ),
      ),
    )
  }

  const itemsColorStyle = { color: isOpaque ? 'black' : 'white' }
  const menuIconProps: any = { style: itemsColorStyle }
  const primaryButtonClasses = isOpaque ? classes.primaryButton : classes.primaryButtonDark

  const sideLinks = isProvider
    ? isBanned
      ? accountMenuItems().providerSideNavLinks.filter((link: any) => link.url === '/account')
      : accountMenuItems(profile).providerSideNavLinks.filter((link) => !link.hidden)
    : isBusinessAccount
    ? accountMenuItems()
        .customerSideNavLinks.filter(
          (link) => (link.isBusiness && showEditBusiness) || !link.isBusiness,
        )
        .filter((link) => (link.isIntegrations && showIntegrations) || !link.isIntegrations)
    : accountMenuItems()
        .customerSideNavLinks.filter((link) => !link.isBusiness)
        .filter((link) => (link.isIntegrations && showIntegrations) || !link.isIntegrations)

  // Really need to refactor those conditions below! //
  return (
    <>
      <div className={headerClasses.container}>
        <div className={classes.credentialBar}>
          <span>USDOT {COMPANY_CREDENTIALS.usdot}</span>
          <span className={classes.credentialDivider} aria-hidden='true' />
          <span>EPA ID {COMPANY_CREDENTIALS.epaId}</span>
        </div>
        <div className={classes.contents}>
          <img
            className={classes.headerLogo}
            onClick={() => history.push('/')}
            style={{ cursor: 'pointer' }}
            src={isOpaque ? dimensionLogoDark.src : dimensionLogo.src}
            alt='Dimension Logo'
          />
          <div className={classes.headerButtons}>
            <div className={classes.menuContainer}>
              {!isLoggedIn && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Our Services'
                  menuItems={ourServicesMenuItems}
                  toggled={toggled}
                  setToggled={setToggled}
                  extended
                />
              )}
              {(!isLoggedIn || !isProvider) && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Business'
                  menuItems={businessMenuItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
              {!isLoggedIn && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Providers'
                  menuItems={providersMenuItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
              {(!isLoggedIn || !isProvider) && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Sustainability'
                  menuItems={sustainabilityItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
              {!isLoggedIn && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='About us'
                  menuItems={aboutUsMenuItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
              {isLoggedIn && !isProvider && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='About us'
                  menuItems={aboutUsMenuItemsCustomer}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
              {!isLoggedIn && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Support'
                  menuItems={supportMenuItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
              {isLoggedIn && !isProvider && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Support'
                  menuItems={loggedInCustomerSupportMenuItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
            </div>
            {isLoggedIn && isProvider && (
              <div className={classes.menuContainer}>
                <Link
                  href='/provider_portal'
                  style={itemsColorStyle}
                  className={classes.menuButton}
                >
                  Provider Portal
                </Link>
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  name='Support'
                  menuItems={loggedInSupportItems}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              </div>
            )}
            <div className={classes.buttonContainer}>
              {!isLoggedIn && (
                <button
                  onClick={handleLogin}
                  className={isOpaque ? classes.secondaryButton : classes.secondaryButtonDark}
                >
                  Log In
                </button>
              )}
              {isProvider && !isBanned && isApproved && (
                <>
                  <Link
                    href='/get_tasks'
                    style={{ width: '140px' }}
                    className={primaryButtonClasses}
                  >
                    Claim Tasks
                  </Link>
                  <Link
                    href='/get_bids'
                    style={{ width: '190px' }}
                    className={primaryButtonClasses}
                  >
                    Bid on Projects
                  </Link>
                </>
              )}
              {!isProvider && (
                <Link
                  href={appLink(
                    `${process.env.NEXT_PUBLIC_REDIRECT_URL}booking?step=initial&redirect=1`,
                  )}
                  className={primaryButtonClasses}
                >
                  Book Now
                </Link>
              )}
              {isLoggedIn && (
                <HeaderMenuItem
                  isOpaque={isOpaque}
                  icon={isOpaque ? accountIconDark.src : accountIcon.src}
                  name='Account'
                  menuItems={[...sideLinks, signOutMenuItem]}
                  toggled={toggled}
                  setToggled={setToggled}
                />
              )}
            </div>
            <button
              className={classes.drawerButton}
              onClick={toggleDrawer(!isDrawerOpen)}
              style={{ paddingRight: 24 }}
            >
              <img
                src={isOpaque ? MenuIconDark.src : MenuIcon.src}
                {...menuIconProps}
                alt='Menu button'
              />
            </button>
          </div>
        </div>
        {isDrawerOpen && (
          <MobileMenu isOpaque={isOpaque} onClose={toggleDrawer(false)} handleLogin={handleLogin} />
        )}
        {/* <LoginModal open={open} closeModal={() => setOpen(false)} /> */}
      </div>
    </>
  )
}

export default Header
